import { ActionReducerMap } from '@ngrx/store';

import { IZendeskRequestsFeatureState } from './interfaces';
import { entityReducer, paginationReducer } from './zendesk-requests.reducer';

export const reducers: ActionReducerMap<IZendeskRequestsFeatureState> = {
  entityState: entityReducer,
  pagination: paginationReducer,
};
